import Alpine from 'alpinejs';

import './Libraries/Accordion/listener';
import './Libraries/Article/listener';
import './Libraries/Lightbox/listener';
import './Libraries/ReadMore/listener';
import './Libraries/ShowMore/listener';
import './Libraries/StickyNav';
import './Libraries/Swiper/listener';
import './Libraries/TippyPopUp';
import './Libraries/VideoEmbed/listener';
import './Libraries/VideoStream/listener';

import {copyLink} from './components/copy-link';
import {basketNotifier} from './components/basket-notifier';
import {basketItem} from './components/basket-add';
import {quantitySelector} from './components/qty-input';
import {mixMatch} from './components/mix-match';
import {promoModal} from './components/promo-modal';
import {drawerModal} from './components/drawer';

if (document.querySelectorAll('.ruk_rating_snippet').length) {
    import('./components/reviews');
}

window.Alpine = Alpine;
Alpine.data('copyLink', copyLink);
Alpine.data('basketNotifier', basketNotifier);
Alpine.data('basketItem', basketItem);
Alpine.data('quantitySelector', quantitySelector);
Alpine.data('mixMatch', mixMatch);
Alpine.data('promoModal', promoModal);
Alpine.data('drawerModal', drawerModal);

Alpine.start();
